import {
  FileTypeGroupsEnum,
  FileBeingAdded,
  FileSourceType,
} from 'service/file/types';
import {
  Asset,
  AssetsSortOrder,
  PartialAssetsFilters,
} from 'store/assets/types';
import { PlanPinSearch } from 'store/plan/actions';
import { PinNew, PinNewWithName } from 'store/plan/types';
import { FieldResult } from 'types/types';
import { createAction, createAsyncAction } from 'typesafe-actions';

export const SET_ASSETS_FILTER =
  createAction('@ASSETS/SET_FILTER')<PartialAssetsFilters>();

export const SET_ASSETS_SORT =
  createAction('@ASSETS/SET_SORT')<AssetsSortOrder>();

export const LOAD_ASSET = createAsyncAction(
  '@ASSETS/LOAD_ASSET.REQUEST',
  '@ASSETS/LOAD_ASSET.SUCCESS',
  '@ASSETS/LOAD_ASSET.FAILURE',
)<string, string, string>();

export const UNLOAD_ASSET = createAction('@ASSETS/UNLOAD_ASSET')<string>();

export const SET_LOADED_ASSET = createAction(
  '@ASSETS/SET_LOADED_ASSET',
)<Asset>();

export const UNSET_LOADED_ASSET = createAction(
  '@ASSETS/UNSET_LOADED_ASSET',
)<string>();

export const TOGGLE_CHOSEN_ASSET = createAction(
  '@ASSETS/TOGGLE_CHOSEN_ASSET',
)<string>();

export const CHOOSE_ALL_FILTERED_ASSETS = createAction(
  '@ASSETS/CHOOSE_ALL_FILTERED_ASSETS',
)();
export const CHOOSE_ASSETS = createAction('@ASSETS/CHOOSE_ASSETS')<string[]>();

export const CLEAR_CHOSEN_ASSETS = createAction(
  '@ASSETS/CLEAR_CHOSEN_ASSETS',
)();

export const DELETE_CHOSEN_ASSETS = createAction(
  '@ASSETS/DELETE_CHOSEN_ASSETS',
)();

export const ENQUEUE_ASSET_DELETE = createAction(
  '@ASSETS/ENQUEUE_ASSET_DELETE',
)<string[]>();

export const doAssetOpenFiles = createAction('doAssetOpenFiles')<{
  assetId: string;
  eventKey: string;
  limitSelectionToFileGroups?: FileTypeGroupsEnum[];
  multiSelect?: boolean;
  promptMessage?: string;
}>();

export const doAssetSaveFilesToAsset = createAction('doAssetSaveFilesToAsset')<
  {
    assetId: string;
    source: FileSourceType;
    files: FileBeingAdded[];
    eventKey: string;
  } & (
    | {
        source: FileSourceType.IMAGE;
        allowVideo: boolean;
      }
    | {
        source: FileSourceType.CAMERA | FileSourceType.FILE;
        allowVideo?: undefined;
      }
  )
>();

export const doAssetFileGetPhotoFromPhoto = createAction(
  'doFileGetPhotoFromPhoto',
)<
  {
    eventKey: string;
  } & (
    | {
        returnType: 'event';
        assetId?: undefined;
      }
    | {
        returnType?: 'saveToAsset';
        assetId: string;
      }
  )
>();

export const ASSET_SAVE_FIELDS = createAction('@ASSETS/SAVE_FIELDS')<{
  results: Record<string, FieldResult>;
  assetId: string;
}>();

export const ASSET_SAVE_REPEATABLE_FIELDS = createAction(
  '@ASSETS/ASSET_SAVE_REPEATABLE_FIELDS',
)<{
  instance: {
    instanceId: string;
    groupId: string;
    autoId: number;
    reference?: string;
    results: Record<string, FieldResult>;
    updatedTs: number;
    action: null | 'delete' | 'remove';
  };
  assetId: string;
}>();

export const doAssetOpenFieldInstance = createAction(
  '@ASSETS/doAssetOpenFieldInstance',
)<{ assetId: string; groupId: string; instanceId: string }>();

export const doAssetDeleteFieldInstance = createAction(
  '@ASSETS/doAssetDeleteFieldInstance',
)<{ assetId: string; instanceId: string }>();

export const doAssetFindFieldInstanceByQR = createAction(
  '@ASSETS/doAssetFindFieldInstanceByQR',
)<{ assetId: string; groupId: string }>();

export const doAssetFoundFieldInstanceByQR = createAction(
  '@ASSETS/doAssetFoundFieldInstanceByQR',
)<{ assetId: string; groupId: string; data: string }>();

export const doAssetFindFieldInstanceByPin = createAction(
  '@ASSETS/doAssetFindFieldInstanceByPin',
)<{ assetId: string; groupId: string }>();

export const doAssetFoundFieldInstanceByPin = createAction(
  '@ASSETS/doAssetFoundFieldInstanceByPin',
)<{ assetId: string; groupId: string; id: string }>();

export const doAssetOpenOverview = createAction('@ASSETS.doAssetOpenOverview')<{
  assetId: string;
}>();

export const doAssetLoadPlans = createAction('@doAssetLoadPlans')<
  {
    findNoun?: string;
    assetId: string;
    actionAfterFind?: {
      type: string;
      payload: PlanPinSearch & Record<string, unknown>;
    };
    selectionKey?: string;
    pin?: PinNew;
    pins: PinNewWithName[];
  } & (
    | { planId?: undefined; pinId?: undefined }
    | { planId: string; pinId?: undefined }
    | { planId?: undefined; pinId: string }
  )
>();
